/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_AdminInputs */

const en_landing_footer_admin = /** @type {(inputs: Landing_Footer_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Panel`)
};

const zh_landing_footer_admin = /** @type {(inputs: Landing_Footer_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理后台`)
};

/**
* | output |
* | --- |
* | "Admin Panel" |
*
* @param {Landing_Footer_AdminInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_admin = /** @type {((inputs?: Landing_Footer_AdminInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_AdminInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_admin(inputs)
	return zh_landing_footer_admin(inputs)
});
export { landing_footer_admin as "landing.footer.admin" }